import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  Container,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
  Col,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import { PencilSquare } from 'react-bootstrap-icons'
import EditEnquiryForm from './EditEnquiryForm'
import Cookies from 'js-cookie'
import axios from 'axios'
import { ChatDots } from 'react-bootstrap-icons'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FaSyncAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'

const EnquiryForm = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedEnquiry, setSelectedEnquiry] = useState(null)

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const initialData = []
  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [statusChanges, setStatusChanges] = useState({})

  const fetchEnquiries = async () => {
    const instituteId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')

    if (!instituteId || !userCookie) return

    try {
      setLoading(true)
      const user = JSON.parse(userCookie)
      const token = user.token

      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Institute-ID': instituteId,
      }

      const response = await axios.get(
        BASE_URL+'/enquiries/all',
        { headers },
      )

      const allData = response.data.data
      const filtered = allData.filter(
        (item) => String(item.institute_id) === String(instituteId),
      )
      setData(filtered)
    } catch (error) {
      console.error('Failed to fetch enquiries:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchEnquiries()
  }, [])

  const [newEnquiry, setNewEnquiry] = useState({
    name: '',
    email: '',
    phone: '',
    course_id: '',
    message: '',
    dob: '',
    gender: '',
    address: '',
    mother_name: '',
    father_name: '',
    parents_number: '',
    institute_id: '',
    enquiry_taken_by: '',
  })

  const [courses, setCourses] = useState([])
  const [enquiries, setEnquiries] = useState([])

  const [institutes, setInstitutes] = useState([])
  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    if (!instituteId) {
      setData([])
      setEnquiries([])
      toast.error('No Institute ID found. Cannot fetch courses.')
      return
    }

    ApiEndpoints.getAllEnquiries()
      .then((response) => {
        const allCourses = response.data.data || []
        setData(allCourses)
        setEnquiries(allCourses)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
    ApiEndpoints.getAllInstitutes().then((res) => setInstitutes(res.data.data))
  }, [])

  const filteredData = data
    .filter((item) => item.status !== 'converted') // Exclude converted
    .filter((item) =>
      Object.values(item).some((value) =>
        value !== null && value !== undefined
          ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
          : false,
      ),
    )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewEnquiry((prev) => ({ ...prev, [name]: value }))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    const userLogged = Cookies.get('user')
    const institueId = Cookies.get('institute_id')
    console.log('INSTITUTE IDdddd', institueId)

    if (userLogged) {
      try {
        setLoading(true)

        const parsedUser = JSON.parse(userLogged)
        const token = parsedUser?.token
        const enquiry_taken_by = parsedUser?.name || parsedUser?.user_id

        const enquiryPayload = {
          ...newEnquiry,
          enquiry_taken_by,
          institute_id: Number(institueId),
        }

        const response = await ApiEndpoints.addEnquiry(enquiryPayload, token)

        // Reset form and fetch updated enquiries
        await fetchEnquiries()

        setNewEnquiry({
          name: '',
          email: '',
          phone: '',
          course_id: '',
          message: '',
          dob: '',
          gender: '',
          address: '',
          mother_name: '',
          father_name: '',
          parents_number: '',
          institute_id: '',
        })

        toast.success(response.data.message)
        setShowModal(false)
      } catch (error) {
        toast.error(error.response?.data?.message)
        setShowModal(false)
      } finally {
        setLoading(false)
      }
    }
  }

  const handleStatusChange = (id, newStatus) => {
    setData((preItems) =>
      preItems.map((item) =>
        item.id === id ? { ...item, status: newStatus } : item,
      ),
    )
  }
  const handleRefresh = async () => {
    setSearch({})

    setData(data)
    setSearch('')
    setCurrentPage(1)
  }

  const handleSubmit = async (enquiry) => {
    try {
      const userCookie = Cookies.get('user')
      const token = JSON.parse(userCookie)?.token

      const studentPayload = {
        enquiryId: enquiry.id,
        name: enquiry.name,
        email: enquiry.email,
        phone: enquiry.phone,
        course_id: enquiry.course_id,
        dob: enquiry.dob,
        gender: enquiry.gender,
        address: enquiry.address,
        mother_name: enquiry.mother_name,
        father_name: enquiry.father_name,
        parents_number: enquiry.parents_number,
        institute_id: enquiry.institute_id,
        admission_date: enquiry.admission_date,
        admission_number: enquiry.admission_number,
        roll_number: enquiry.roll_number,
        whatsapp_number: enquiry.whatsapp_number,
        id_proof_number: enquiry.id_proof_number,
        id_proof_type: enquiry.id_proof_type,
      }

      const response = await ApiEndpoints.addStudent(studentPayload, token)

      const studentId = response?.data?.data?.id

      toast.success(response.data.message)

      navigate(`/UpdateStudentEnquiry/${studentId}`, {
        state: { enquiry, status: 'Active' },
      })
    } catch (error) {
      const errorMessage = error?.response?.data?.message

      if (
        errorMessage &&
        errorMessage.includes('Duplicate entry') &&
        errorMessage.includes('students.email')
      ) {
        console.error('A student with this email already exists.')
      } else {
        toast.error(errorMessage || 'Something went wrong during registration.')
      }

      console.error('Add Student Error:', error)
    }
  }

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Enquiries</h2>
          <Button
            variant="light"
            className="fw-bold"
            onClick={() => setShowModal(true)}
          >
            <ChatDots size={18} className="me-2" />
            Add Enquiry
          </Button>
        </div>
      </div>

      <Row className="g-2 align-items-center justify-content-between mt-4">
        <Col xs={12} md={6}>
          <Form.Control
            type="text"
            placeholder="Search Student Name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>
      {/* Bottom Row: Total Courses and Items Per Page */}
      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <p className="text-black m-0">Total Enquiries: {filteredData.length}</p>
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="30">30 per page</option>
        </Form.Select>
      </div>

      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr>
            <Th>Enquiry Date</Th>
            <Th>Student Name</Th>
            <Th>Phone</Th>
            <Th>Message</Th>
            <Th>Enquiry By</Th>
            <Th>Status</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <Tr key={index} className="align-middle">
                <Td>
                  {' '}
                  {item?.created_at
                    ? new Date(item.created_at).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                      })
                    : 'N/A'}
                </Td>
                <Td>{item.name}</Td>
                <Td>{item.phone}</Td>
                <Td>{item.message}</Td>
                <Td>{item.enquiry_by}</Td>
                <Td>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <select
                      className={`form-select btn btn-sm ${
                        (statusChanges[item.id] || item.status) === 'converted'
                          ? 'btn-success'
                          : (statusChanges[item.id] || item.status) ===
                            'rejected'
                          ? 'btn-danger'
                          : 'btn-warning'
                      }`}
                      value={statusChanges[item.id] || item.status}
                      onChange={(e) =>
                        setStatusChanges((prev) => ({
                          ...prev,
                          [item.id]: e.target.value,
                        }))
                      }
                    >
                      <option value="pending">Pending</option>
                      <option value="converted">Converted</option>
                      <option value="rejected">Rejected</option>
                    </select>

                    <button
                      className="btn btn-sm btn-primary"
                      onClick={async () => {
                        const updatedStatus =
                          statusChanges[item.id] || item.status

                        if (updatedStatus === 'converted') {
                          // Try converting to student
                          await handleSubmit({ ...item, status: updatedStatus })
                        }

                        // Apply status change locally after student conversion (if needed)
                        handleStatusChange(item.id, updatedStatus)
                        // toast.success('Status updated successfully!')
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </Td>

                <Td className="text-center">
                  <div className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2">
                    <Button
                      variant="warning"
                      className="d-flex flex-wrap justify-content-center align-items-center gap-2"
                      onClick={() => {
                        setSelectedEnquiry(item)
                        setShowEditModal(true)
                      }}
                    >
                      <PencilSquare />
                    </Button>
                  </div>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan="9" className="text-center text-muted fw-bold p-4">
                No records found
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      <div className="d-flex justify-content-end align-items-center">
        <Pagination className="mt-2">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add New Class Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New Enquiry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newEnquiry.name}
                onChange={handleInputChange}
                placeholder="Enter name"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Date of Birth *</Form.Label>
              <Form.Control
                type="date"
                name="dob"
                value={newEnquiry.dob}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Gender *</Form.Label>

              <div>
                <Form.Check
                  inline
                  type="radio"
                  name="gender"
                  label="Male"
                  value="Male"
                  checked={newEnquiry.gender === 'Male'}
                  onChange={handleInputChange}
                  required
                />
                <Form.Check
                  inline
                  type="radio"
                  name="gender"
                  label="Female"
                  value="Female"
                  checked={newEnquiry.gender === 'Female'}
                  onChange={handleInputChange}
                />
                <Form.Check
                  inline
                  type="radio"
                  name="gender"
                  label="Other"
                  value="Other"
                  checked={newEnquiry.gender === 'Other'}
                  onChange={handleInputChange}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Father's Name</Form.Label>
              <Form.Control
                type="text"
                name="father_name"
                value={newEnquiry.father_name}
                onChange={handleInputChange}
                placeholder="Enter father's name"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mother's Name</Form.Label>
              <Form.Control
                type="text"
                name="mother_name"
                value={newEnquiry.mother_name}
                onChange={handleInputChange}
                placeholder="Enter mother's name"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Course</Form.Label>
              <Form.Select
                name="course_id"
                value={newEnquiry.course_id}
                onChange={handleInputChange}
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                value={newEnquiry.phone}
                onChange={handleInputChange}
                placeholder="Enter phone number"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newEnquiry.email}
                onChange={handleInputChange}
                placeholder="Enter email"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Address *</Form.Label>
              <Form.Control
                as="textarea"
                name="address"
                value={newEnquiry.address}
                onChange={handleInputChange}
                placeholder="Enter address"
                rows={3}
                required
              />
            </Form.Group>
            {/* Description */}
            <Form.Group className="mb-3">
              <Form.Label>Parent's Number</Form.Label>
              <Form.Control
                type="tel"
                name="parents_number"
                value={newEnquiry.parents_number}
                onChange={handleInputChange}
                placeholder="Enter parent's phone number"
              />
            </Form.Group>
            <FormGroup className="mb-3">
              <FormLabel>Institute *</FormLabel>
              <FormSelect
                name="institute_id"
                value={newEnquiry.institute_id}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Institute</option>
                {institutes.map((institute) => (
                  <option key={institute.id} value={institute.institute_id}>
                    {institute.name}
                  </option>
                ))}
              </FormSelect>
            </FormGroup>
            <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                value={newEnquiry.message}
                onChange={handleInputChange}
                placeholder="Drop your message"
                rows={3}
              />
            </Form.Group>
            <Modal.Footer>
              <Button
                variant="danger"
                className="rounded-pill px-4"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="success"
                className="rounded-pill px-4"
                type="submit"
              >
                Save Enquiry
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditEnquiryForm
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        enquiry={selectedEnquiry}
      />
    </div>
  )
}

export default EnquiryForm
